import PosPage from "@/pages/pos/pos-page";
import { route } from "../utils";
import { RouteType } from "../types";

export const posRoutes: Record<string, RouteType> = {
  pos: route("/pos", PosPage),
};
